"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminTestGg = void 0;
const React = __importStar(require("react"));
const react_1 = require("react");
const SkeletonComponent_1 = require("src/configeek_assets/src/components/common/SkeletonComponent");
const PageContent_1 = require("src/configeek_assets/src/components/common/widget/PageContent");
const antd_1 = require("antd");
const lodash_1 = __importDefault(require("lodash"));
const configeek_ic_js_1 = require("configeek-ic-js");
const AdminTestGgInternal = () => {
    const [initFinished, setInitFinished] = (0, react_1.useState)(false);
    const [apiKey, setApiKey] = (0, react_1.useState)("");
    const [automaticFetchingEnabled, setAutomaticFetchingEnabled] = (0, react_1.useState)(false);
    const [allConfig, setAllConfig] = (0, react_1.useState)(undefined);
    const [updatedKeys, setUpdatedKeys] = (0, react_1.useState)([]);
    const readAllConfig = (0, react_1.useCallback)(() => {
        setAllConfig(configeek_ic_js_1.Configeek.getAll());
    }, []);
    const onClickInitialize = (0, react_1.useCallback)(() => {
        if (!initFinished && !lodash_1.default.isEmpty(apiKey)) {
            configeek_ic_js_1.Configeek.init({
                apiKey: apiKey,
                onConfigurationUpdatedCallback: ({ updatedKeys }) => {
                    setUpdatedKeys(updatedKeys);
                    readAllConfig();
                },
                fetchIntervalMillis: 1000 * 60
            });
            setInitFinished(true);
            readAllConfig();
        }
    }, [initFinished, apiKey]);
    const togglePeriodicFetch = (0, react_1.useCallback)(() => {
        if (configeek_ic_js_1.Configeek.isPeriodicFetchingEnabled) {
            configeek_ic_js_1.Configeek.stopPeriodicFetching();
            setAutomaticFetchingEnabled(false);
        }
        else {
            configeek_ic_js_1.Configeek.startPeriodicFetching();
            setAutomaticFetchingEnabled(true);
        }
    }, []);
    const destroySDK = (0, react_1.useCallback)(() => {
        configeek_ic_js_1.Configeek.destroy();
        setInitFinished(false);
    }, []);
    (0, react_1.useEffect)(() => {
        readAllConfig();
    }, []);
    if (!initFinished) {
        return React.createElement(PageContent_1.PageContent, null,
            React.createElement(PageContent_1.PageContent.Card, null,
                React.createElement("h3", null, "Initialize confiGeek"),
                React.createElement(antd_1.Space, { direction: "horizontal" },
                    React.createElement(antd_1.Input, { value: apiKey, placeholder: "ApiKey...", onChange: event => setApiKey(event.target.value), style: { width: 400 } }),
                    React.createElement(antd_1.Button, { onClick: onClickInitialize }, "Initialize SDK"))));
    }
    return React.createElement(PageContent_1.PageContent, null,
        React.createElement(PageContent_1.PageContent.Card, null,
            React.createElement("h3", null,
                "Project API Key ",
                apiKey),
            React.createElement(antd_1.Space, { direction: "vertical", style: { width: "100%" } },
                React.createElement("div", null,
                    "Updated parameters:",
                    React.createElement("pre", null, JSON.stringify(updatedKeys))),
                React.createElement("div", null,
                    "Full config:",
                    React.createElement("pre", null, JSON.stringify(allConfig, null, 4))),
                React.createElement(antd_1.Button, { onClick: togglePeriodicFetch },
                    "Turn periodic fetch ",
                    automaticFetchingEnabled ? "Off" : "On"),
                React.createElement(antd_1.Button, { onClick: () => configeek_ic_js_1.Configeek.fetchConfig() }, "Force fetch")),
            React.createElement(antd_1.Button, { onClick: destroySDK, danger: true, style: { marginTop: 50 } }, "Destroy SDK")));
};
const AdminTestGg = () => {
    return React.createElement(SkeletonComponent_1.TestServerRenderComponent, null,
        React.createElement(AdminTestGgInternal, null));
};
exports.AdminTestGg = AdminTestGg;
